import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/state'
import {
  setDrawerAction,
  uiGlobalSelector,
} from '@/state/ui/global/slices/index.slices'

const useWalletReportDrawer = () => {
  const dispatch = useAppDispatch()

  const { formMode, drawer } = useSelector(uiGlobalSelector)

  const toggleDrawer = (open: boolean) => {
    dispatch(setDrawerAction({ open }))
  }

  return {
    drawer,
    toggleDrawer,
    formMode,
  }
}

export default useWalletReportDrawer
